import { TextArea } from '@traceair/tds';
import { stylesheet } from 'typestyle';
import { GcpRequestData, useUploadStore } from '../../../../../store/uploadStore';
import { ProjectData } from '../../types';

const css = stylesheet({
  container: {
    marginBottom: 24,
  },
});

interface Props extends ProjectData {
  gcpRequest: GcpRequestData;
}

export const GcpRequestUploadComment = ({ customer, site, gcpRequest }: Props) => {
  const { setGcpRequest } = useUploadStore();

  const handleChange = (v: string) => {
    gcpRequest.comment = v;
    setGcpRequest(customer.id, site.id, gcpRequest);
  };

  if (!gcpRequest.meta.isEditMode && !gcpRequest.comment) {
    return null;
  }

  return (
    <div className={css.container}>
      <TextArea
        disabled={!gcpRequest.meta.isEditMode}
        maxRows={10}
        hidePlaceholderOnFocus
        label="Comment"
        placeholder="Comment"
        value={gcpRequest.comment}
        onChange={handleChange}
      />
    </div>
  );
};
